<template>
  <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
          <v-card-component title="Assign Bus Route To Student" icon="mdi-bus">
            <v-card-actions>
              <router-link :to="{ name: 'assignBusRouteStudentListing' }">
                <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
                <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
              </router-link>
            </v-card-actions>
            <v-row>
              <v-col>
                <!-- <v-row>
                  <v-col cols="12" lg="4" sm="6">
                    <span class="body-2 font-weight-medium"> Academic Year</span>
                    <span class="error--text ml-1">*</span>
                    <v-autocomplete
                      required
                      v-model="academicYearID"
                      key="id"
                      @change="clearData()"
                      class="my-0 py-1"
                      single-line
                      placeholder="---Select---"
                      :items="academicYears"
                      item-text="academicYear"
                      item-value="id"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="4" sm="6">
                    <span class="body-2 font-weight-medium">Select Franchisee</span>
                    <span class="error--text ml-1">*</span>
                    <v-autocomplete
                      v-model="franchiseeID"
                      key="id"
                      @change="getVehicleRouteList()"
                      class="my-0 py-1"
                      required
                      single-line
                      placeholder="---Select---"
                      :items="franchiseeArr"
                      item-text="companyName"
                      item-value="id"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" lg="4" sm="6">
                    <span class="body-2 font-weight-medium">
                      Select Vehicle Route
                    </span>
                    <span class="error--text ml-1">*</span>
                    <v-autocomplete
                      v-model="vehicleRouteID"
                      key="id"
                      class="my-0 py-1"
                      @change="getVehicleRouteStopList()"
                      required
                      single-line
                      placeholder="---Select---"
                      :items="vehicleRouteDetails"
                      item-text="routeName"
                      return-object
                    >
                    </v-autocomplete>
                    <v-chip color="orange" v-if="vehicleRouteID" label>Vehicle No: {{ vehicleRouteID.vehicleDetail.vehicleRegistrationNumber }}</v-chip>
                  </v-col>
                  <v-col cols="12" lg="4" sm="6">
                    <span class="body-2 font-weight-medium">Select Vehicle Route Stop</span>
                    <span class="error--text ml-1">*</span>
                    <v-autocomplete v-model="pickUpStopID" key="id" class="my-0 py-1" required single-line placeholder="---Select---" :items="VehicleRouteStop" item-text="pickUpStop" item-value="id">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="4" md="6">
                    <label class="body-2 font-weight-medium"> Class <span class="error--text">*</span> </label>
                    <v-autocomplete
                      class="my-0 py-1"
                      placeholder="--Select--"
                      name="classSelect"
                      required
                      v-model="selectedClassID"
                      v-on:change="changeSections()"
                      item-value="id"
                      :items="classes"
                      key="id"
                      item-text="name"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="4" md="6">
                    <label class="body-2 font-weight-medium"> Select Section <span class="error--text">*</span> </label>
                    <v-autocomplete
                      class="my-0 py-1"
                      placeholder="--Select--"
                      v-on:change="students()"
                      required
                      name="sectionSelect"
                      v-model="selectedSectionID"
                      item-value="id"
                      :items="classWiseSections"
                      item-text="name"
                      key="id"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="4" md="6">
                    <label class="body-2 font-weight-medium"> Select Student <span class="error--text">*</span> </label>
                    <v-autocomplete item-value="id" class="my-0 py-1" placeholder="--Select--" required name="sectionSelect" v-model="selectedStudent" :items="studentArray" key="id" item-text="name">
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;">Create</button>
          </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'assignBusRouteStudent',
  components: {
    VCardComponent
  },
  data () {
    return {
      total: 0,
      vehicleRouteID: '',
      franchiseeID: '',
      franchiseeArr: [],
      pickUpStopID: '',
      selectedStudent: '',
      studentArray: [],
      classes: [],
      sections: [],
      tempArray: [],
      academicYearID: '',
      selectedClassID: '',
      selectedSectionID: '',
      academicYears: [],
      vehicleRouteDetails: [],
      classWiseSections: [],
      routeName: '',
      VehicleRouteStop: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      allowedFiles: ['png', 'jpg', 'jpeg', 'pdf']
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: function (val) {
      this.franchiseeID = val.id
      this.getVehicleRouteList()
    },
    academicYear: function (val) {
      this.academicYearID = val
      this.getVehicleRouteList()
      this.clearData()
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    // await this.getYear()
    // await this.getFranchiseeList()
    await this.getClassList()
    await this.getVehicleRouteList()
  },
  methods: {
    getVehicleRouteList: async function () {
      try {
        this.vehicleRouteDetails = []
        this.isLoading = true
        let getParam = {}
        getParam.franchiseeID = this.franchisee.id
        getParam.academicYearID = this.academicYear.id
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroute`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data ',
            message: 'No Vehicle Route Registered With Selected Franchisee and Academic year',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleRouteDetails = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getVehicleRouteStopList: async function () {
      try {
        let getParam = {}
        getParam.busRouteID = this.vehicleRouteID.id
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroutestop`, {
          params: getParam
        })

        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Vehicle Route Stop Registered With Selected Vehicle Route',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.VehicleRouteStop = data
          this.busRoute = this.VehicleRouteStop[0].vehicleBusRoute.routeName
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/student/class-section?isRequired=false`)
        if (data) {
          this.classes = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name
            }
          })
          this.sections = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name,
              sections: obj.studentSections
            }
          })
        }
        data.map(a => {
          a.studentSections.map(b => {
            this.tempArray.push({
              id: b.id,
              name: `${a.name}-${b.name}`
            })
          })
        })
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    changeSections: async function () {
      this.selectedStudent = ''
      this.studentArray = []
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = 0
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    students: async function () {
      if (!this.franchisee.id || !this.academicYear.id) {
        return this.errMsg('Please select franchisee ')
      }
      this.selectedStudent = ''
      this.studentArray = []
      let studentData = {
        isActive: 'true',
        franchiseeID: this.franchisee.id,
        classID: this.selectedClassID,
        sectionID: this.selectedSectionID,
        academicYearID: this.academicYear.id
      }
      try {
        this.isLoading = true
        let { data } = await http.post(`${constants.API_URL}/api/student`, studentData)
        if (data.length === 0) {
          this.$dialog.notify.warning(`No student Found with selected class and section`, {
            position: 'top-right',
            timeout: 5000
          })
        } else {
          this.studentArray = data.map(a => {
            return {
              id: a.id,
              name: a.studentEnrollment.studentName
            }
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('busRouteID', this.vehicleRouteID.id)
        formData.append('busStopID', this.pickUpStopID)
        formData.append('studentID', this.selectedStudent)
        formData.append('vehicleID', this.vehicleRouteID.vehicleID)
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.post(`${constants.API_URL}/api/transport/vehicleRouteAssignStudents/vehicleRouteAssignStudents`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'assignBusRouteStudentListing' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearData () {
      this.vehicleRouteDetails = []
      this.franchiseeID = ''
      this.vehicleRouteID = ''
      this.vehicleCleanerDetails = []
      this.VehicleRouteStop = []
      this.pickUpStopID = ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
